import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: string;
    loading: string;
    successMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useVersionAsset.errorMessage?c=2ox21lgtv2e9r", defaultMessage: "Couldn\u2019t add new version" }));
                },
                enumerable: true,
                configurable: true
            },
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useVersionAsset.loading?c=3jpdw71jyvdc5", defaultMessage: "Adding new version\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useVersionAsset.successMessage?c=2g493p3r0knq", defaultMessage: "Version added successfully" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
